import { MoodsByTimeRange } from '../graphs/utils.type';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { format, parse } from "date-fns";

@Injectable(
    { providedIn: 'root' }
)
export class StatsService {
    constructor(private http: HttpClient)
    { }

    private to_local_date(date_from_api: string) {
        return format(parse(date_from_api, 'dd-MM-yyyy', new Date()), 'PP');
    }

    async best_day(url_params: string) {
        const response = await firstValueFrom(this.http.get<{ date: string }>(`/api/stats/mood-scores/max/entire-period?${url_params}`));
        return response?.date ? this.to_local_date(response.date) : ('--/--/--');
    }

    async worst_day(url_params: string) {
        const response = await firstValueFrom(this.http.get<{ date: string }>(`/api/stats/mood-scores/min/entire-period?${url_params}`));
        return response?.date ? this.to_local_date(response.date) : ('--/--/--');
    }

    async global_average(url_params: string): Promise<any> {
        const response = await firstValueFrom(this.http.get<{ score: string }>(`/api/stats/mood-scores/average/entire-period?${url_params}`));
        return response?.score ? response.score : ('-');
    }

    async mood_distribution_for_entire_period(url_params: string) {
        const response = await firstValueFrom(this.http.get<any>(`/api/stats/mood-counts/grouped-by-mood/entire-period?${url_params}`));
        return response ? response : {};
    }

    async moods_distribution_by_day(url_params: string) {
        const response = await firstValueFrom(this.http.get<{countsByDay: MoodsByTimeRange[]}>(`/api/stats/mood-counts/grouped-by-mood/by-day?${url_params}`));
        return response?.countsByDay ? response.countsByDay : [];
    }

    async wordcloud(url_params: string, language: string) {
        const response = await firstValueFrom(this.http.get<any>(`/api/stats/word-counts/grouped-by-word/entire-period?${url_params}&lang=${language}`));
        return response ? response : [];
    }

    async usage(url_params: string) {
        const response = await firstValueFrom(this.http.get<any>(`/api/stats/usage-chart?${url_params}`));
        return response ? response : [];
    }

    async all_org_units(url_params?: string) {
        const params = (typeof url_params !== 'undefined') ? `?${url_params}` : "";
        return await firstValueFrom(this.http.get<any>(`/api/user/orgunits/all${params}`));
    }
}